module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "dedication",
    attrs: {
      "id": "A3g"
    }
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "section_level_h1_01",
      "role": "doc-chapter",
      "title": "Dedication"
    }
  }, [_c('p', [_c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center",
    attrs: {
      "id": "pz3-1"
    }
  }, [_c('em', [_vm._v("For Adam, my son"), _c('br'), _vm._v(" and in many ways my teacher.")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', [_vm._v("Son, how can I help you see?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-3"
    }
  }, [_vm._v("May I give you my shoulders to stand on?")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-4"
    }
  }, [_vm._v("Now you see farther than me.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-5"
    }
  }, [_vm._v("Now you see for both of us.")]), _vm._v(" "), _c('p', {
    attrs: {
      "id": "pz5-6"
    }
  }, [_vm._v("Won’t you tell me what you see?")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45e332cd","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dedication.vue
// module id = 66
// module chunks = 0